import _classCallCheck from "/Users/john/workspace/test/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john/workspace/test/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { C, Grammar } from "../core";
/**
 * A messager sends a {@link Message} (outgoing MESSAGE).
 * @public
 */
export var Messager = /*#__PURE__*/function () {
  /**
   * Constructs a new instance of the `Messager` class.
   * @param userAgent - User agent. See {@link UserAgent} for details.
   * @param targetURI - Request URI identifying the target of the message.
   * @param content - Content for the body of the message.
   * @param contentType - Content type of the body of the message.
   * @param options - Options bucket. See {@link MessagerOptions} for details.
   */
  function Messager(userAgent, targetURI, content) {
    var contentType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "text/plain";
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    _classCallCheck(this, Messager);
    // Logger
    this.logger = userAgent.getLogger("sip.Messager");
    // Default options params
    options.params = options.params || {};
    // URIs
    var fromURI = userAgent.userAgentCore.configuration.aor;
    if (options.params.fromUri) {
      fromURI = typeof options.params.fromUri === "string" ? Grammar.URIParse(options.params.fromUri) : options.params.fromUri;
    }
    if (!fromURI) {
      throw new TypeError("Invalid from URI: " + options.params.fromUri);
    }
    var toURI = targetURI;
    if (options.params.toUri) {
      toURI = typeof options.params.toUri === "string" ? Grammar.URIParse(options.params.toUri) : options.params.toUri;
    }
    if (!toURI) {
      throw new TypeError("Invalid to URI: " + options.params.toUri);
    }
    // Message params
    var params = options.params ? Object.assign({}, options.params) : {};
    // Extra headers
    var extraHeaders = (options.extraHeaders || []).slice();
    // Body
    var contentDisposition = "render";
    var body = {
      contentDisposition: contentDisposition,
      contentType: contentType,
      content: content
    };
    // Build the request
    this.request = userAgent.userAgentCore.makeOutgoingRequestMessage(C.MESSAGE, targetURI, fromURI, toURI, params, extraHeaders, body);
    // User agent
    this.userAgent = userAgent;
  }
  /**
   * Send the message.
   */
  _createClass(Messager, [{
    key: "message",
    value: function message() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.userAgent.userAgentCore.request(this.request, options.requestDelegate);
      return Promise.resolve();
    }
  }]);
  return Messager;
}();